import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout-error',
  standalone: true,
  imports: [],
  templateUrl: './layout-error.component.html',
  styleUrl: './layout-error.component.scss',
})
export class LayoutErrorComponent implements OnInit, OnDestroy {
  private router = inject(Router);

  timer = 5;
  intervalId: any;

  ngOnInit(): void {
    this.startTimer();
    setTimeout(() => this.goToHome(), 5000);
  }

  startTimer(): void {
    this.intervalId = setInterval(() => {
      if (this.timer > 0) this.timer--;
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  goToHome(): void {
    this.router.navigate(['/login']);
  }
}
